/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getCustomer = /* GraphQL */ `
  query GetCustomer($id: ID!) {
    getCustomer(id: $id) {
      createdAt
      updatedAt
      id
      name
      netsuiteID
      services {
        id
        name
        children {
          id
          name
          children {
            id
            name
            children {
              id
              name
            }
          }
        }
      }
      ssoDomain
      selfValidation
      defaultRoles
      customerOf
      appClientID
      appClientScopes
      tradeinteropMemberId
      isTemplate
      createdFromTemplate
      errorNotificationAddress
      partner
      documentRetentionDays
    }
  }
`;
export const listCustomers = /* GraphQL */ `
  query ListCustomers(
    $filter: ModelCustomerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        updatedAt
        id
        name
        netsuiteID
        services {
          id
          name
          children {
            id
            name
            children {
              id
              name
            }
          }
        }
        ssoDomain
        selfValidation
        defaultRoles
        customerOf
        appClientID
        appClientScopes
        tradeinteropMemberId
        isTemplate
        createdFromTemplate
        errorNotificationAddress
        partner
        documentRetentionDays
      }
      nextToken
    }
  }
`;
export const getCustomerReport = /* GraphQL */ `
  query GetCustomerReport($id: ID!) {
    getCustomerReport(id: $id) {
      id
      createdAt
      updatedAt
      tableauCustomerGuid
      tableauUser
      reports {
        name
        url
      }
    }
  }
`;
export const listCustomerReports = /* GraphQL */ `
  query ListCustomerReports(
    $filter: ModelCustomerReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCustomerReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        tableauCustomerGuid
        tableauUser
        reports {
          name
          url
        }
      }
      nextToken
    }
  }
`;
export const getCompanyData = /* GraphQL */ `
  query GetCompanyData($customerID: String!, $id: ID!) {
    getCompanyData(customerID: $customerID, id: $id) {
      id
      createdAt
      updatedAt
      customerID
      name
      companyCode
      businessUnit
      gln
      coc
      vatID
      address
      city
      postalCode
      opCo
      emailAddress
      businessArea
      synonyms {
        operator
        value
      }
      exportType
      addressLine2
      country
      IBAN
      BIC
      termsAndConditions
      isoCode
      active
      default
    }
  }
`;
export const listCompanyData = /* GraphQL */ `
  query ListCompanyData(
    $customerID: String
    $id: ModelIDKeyConditionInput
    $filter: ModelCompanyDataFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCompanyData(
      customerID: $customerID
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        createdAt
        updatedAt
        customerID
        name
        companyCode
        businessUnit
        gln
        coc
        vatID
        address
        city
        postalCode
        opCo
        emailAddress
        businessArea
        synonyms {
          operator
          value
        }
        exportType
        addressLine2
        country
        IBAN
        BIC
        termsAndConditions
        isoCode
        active
        default
      }
      nextToken
    }
  }
`;
export const getDomainSetting = /* GraphQL */ `
  query GetDomainSetting($customerID: String!, $domain: String!) {
    getDomainSetting(customerID: $customerID, domain: $domain) {
      id
      createdAt
      updatedAt
      customerID
      denied
      domain
      ignoredFiles
      fileTypeProcess {
        process
        friendlyProcessName
        filePattern
      }
      excluded {
        type
        search
      }
    }
  }
`;
export const listDomainSettings = /* GraphQL */ `
  query ListDomainSettings(
    $customerID: String
    $domain: ModelStringKeyConditionInput
    $filter: ModelDomainSettingFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDomainSettings(
      customerID: $customerID
      domain: $domain
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        createdAt
        updatedAt
        customerID
        denied
        domain
        ignoredFiles
        fileTypeProcess {
          process
          friendlyProcessName
          filePattern
        }
        excluded {
          type
          search
        }
      }
      nextToken
    }
  }
`;
export const getDocument = /* GraphQL */ `
  query GetDocument($id: ID!) {
    getDocument(id: $id) {
      id
      icGuid
      createdAt
      createdEpoch
      updatedAt
      amountGross
      amountNet1
      amountNet2
      amountNet3
      amountNetTotal
      amountVat1
      amountVat2
      amountVat3
      amountVatTotal
      appliedMapping
      bankName
      btBUMID
      btInvoiceRef
      btOrigin
      btReceiverRef
      btScanDate
      businessArea
      businessUnit
      companyID
      companyCode
      companyName
      companyNameOverride
      currency
      customerID
      deliveryDate
      deliveryTerms
      deliveryEndDate
      deliveryLocation
      deliveryInstruction
      documentNumber
      documentSubType
      documentType
      dueDate
      expiresAt
      exportApproved
      exportMapping
      exportType
      externalSystem
      externalSystemID
      forceValid
      gAccount
      gAmount
      invoiceDate
      invoiceNumber
      invoiceType
      integrationDetail
      ivsProcessID
      lastError
      noteNumber
      noteToSupplier
      opCo
      owner
      orderDate
      orderType
      paymentTerms
      pdfUploadedFrontEnd
      purchasingCategory
      poCreator
      poOwner
      purpose
      receivedMessageID
      receiverAddress1
      receiverAddress2
      receiverCity
      receiverCompanyName
      receiverCompanyCode
      receiverContractNumber
      receiverCountryCode
      receiverContactName
      receiverContactFirstName
      receiverContactPhoneNumber
      receiverContactEmailAddress
      receiverGLN
      receiverKVK
      receiverNetServiceId
      receiverOrdernumber
      receiverPostalCode
      receiverVatId
      receiverEmailAddress
      receiverEndPointIsoCode
      receiverEndPointID
      remark
      returnDate
      returnEmailAddress
      returnStatus
      s3ResourceAttachment {
        s3Resource
      }
      s3ResourceMiscellaneous {
        s3Resource
      }
      s3ResourceWebserviceResponse
      s3ResourceExportedDocument
      s3ResourceGeneratedImage
      s3ResourceOrgImage
      s3ResourceOrgXML
      source
      status
      secondaryStatus
      senderCode
      senderAddress1
      senderAddress2
      senderCompanyCode
      senderContractNumber
      senderCountryCode
      senderContactName
      senderContactFirstName
      senderContactPhoneNumber
      senderContactEmailAddress
      senderDescription
      senderDocCode
      senderDocNum
      senderEmailAddress
      senderGLN
      senderIBAN
      senderName
      senderNote
      senderReference
      senderTerms
      senderPostalCode
      senderVatId
      senderKVK
      subscriptionType
      supplierAddress1
      supplierAddress2
      supplierBBAN
      supplierCity
      supplierCountryCode
      supplierDescription
      supplierEmailAddress
      supplierGLN
      supplierIBAN
      supplierKVK
      supplierName
      supplierNetServiceId
      supplierCode
      senderRecognitionInput
      supplierRecognitionInput
      supplierOrdernumber
      supplierPostalCode
      supplierVatId
      swiftCode
      vatRate1
      vatRate2
      vatRate3
      history {
        id
        createdAt
        user
        description
        type
        documentChanges {
          field
          oldValue
          newValue
        }
      }
      lines {
        id
        lineNumber
        lineNetTotal
        lineVatRate
        lineVatAmount
        lineUnitPrice
        lineQuantity
        lineDescription
        lineUoM
        lineArticleCode
        lineSupplierArticleCode
        lineOrderNumber
        lineDiscountRate
        lineDiscountAmount
        lineDiscountName
        lineFreeNumber1
        lineFreeNumber2
        lineFreeNumber3
        lineFreeText1
        lineFreeText2
        lineFreeText3
      }
      locked
      lockedBy
      lockedSince
      hasBeenReProcessed
      sendScanReportToBasware
      scanReportCode
      scanReportDescription
      scanReportComment
      title
      linkedDocuments {
        documentID
        documentType
      }
    }
  }
`;
export const listDocuments = /* GraphQL */ `
  query ListDocuments(
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        icGuid
        createdAt
        createdEpoch
        updatedAt
        amountGross
        amountNet1
        amountNet2
        amountNet3
        amountNetTotal
        amountVat1
        amountVat2
        amountVat3
        amountVatTotal
        appliedMapping
        bankName
        btBUMID
        btInvoiceRef
        btOrigin
        btReceiverRef
        btScanDate
        businessArea
        businessUnit
        companyID
        companyCode
        companyName
        companyNameOverride
        currency
        customerID
        deliveryDate
        deliveryTerms
        deliveryEndDate
        deliveryLocation
        deliveryInstruction
        documentNumber
        documentSubType
        documentType
        dueDate
        expiresAt
        exportApproved
        exportMapping
        exportType
        externalSystem
        externalSystemID
        forceValid
        gAccount
        gAmount
        invoiceDate
        invoiceNumber
        invoiceType
        integrationDetail
        ivsProcessID
        lastError
        noteNumber
        noteToSupplier
        opCo
        owner
        orderDate
        orderType
        paymentTerms
        pdfUploadedFrontEnd
        purchasingCategory
        poCreator
        poOwner
        purpose
        receivedMessageID
        receiverAddress1
        receiverAddress2
        receiverCity
        receiverCompanyName
        receiverCompanyCode
        receiverContractNumber
        receiverCountryCode
        receiverContactName
        receiverContactFirstName
        receiverContactPhoneNumber
        receiverContactEmailAddress
        receiverGLN
        receiverKVK
        receiverNetServiceId
        receiverOrdernumber
        receiverPostalCode
        receiverVatId
        receiverEmailAddress
        receiverEndPointIsoCode
        receiverEndPointID
        remark
        returnDate
        returnEmailAddress
        returnStatus
        s3ResourceAttachment {
          s3Resource
        }
        s3ResourceMiscellaneous {
          s3Resource
        }
        s3ResourceWebserviceResponse
        s3ResourceExportedDocument
        s3ResourceGeneratedImage
        s3ResourceOrgImage
        s3ResourceOrgXML
        source
        status
        secondaryStatus
        senderCode
        senderAddress1
        senderAddress2
        senderCompanyCode
        senderContractNumber
        senderCountryCode
        senderContactName
        senderContactFirstName
        senderContactPhoneNumber
        senderContactEmailAddress
        senderDescription
        senderDocCode
        senderDocNum
        senderEmailAddress
        senderGLN
        senderIBAN
        senderName
        senderNote
        senderReference
        senderTerms
        senderPostalCode
        senderVatId
        senderKVK
        subscriptionType
        supplierAddress1
        supplierAddress2
        supplierBBAN
        supplierCity
        supplierCountryCode
        supplierDescription
        supplierEmailAddress
        supplierGLN
        supplierIBAN
        supplierKVK
        supplierName
        supplierNetServiceId
        supplierCode
        senderRecognitionInput
        supplierRecognitionInput
        supplierOrdernumber
        supplierPostalCode
        supplierVatId
        swiftCode
        vatRate1
        vatRate2
        vatRate3
        history {
          id
          createdAt
          user
          description
          type
          documentChanges {
            field
            oldValue
            newValue
          }
        }
        lines {
          id
          lineNumber
          lineNetTotal
          lineVatRate
          lineVatAmount
          lineUnitPrice
          lineQuantity
          lineDescription
          lineUoM
          lineArticleCode
          lineSupplierArticleCode
          lineOrderNumber
          lineDiscountRate
          lineDiscountAmount
          lineDiscountName
          lineFreeNumber1
          lineFreeNumber2
          lineFreeNumber3
          lineFreeText1
          lineFreeText2
          lineFreeText3
        }
        locked
        lockedBy
        lockedSince
        hasBeenReProcessed
        sendScanReportToBasware
        scanReportCode
        scanReportDescription
        scanReportComment
        title
        linkedDocuments {
          documentID
          documentType
        }
      }
      nextToken
    }
  }
`;
export const getCrudHistory = /* GraphQL */ `
  query GetCrudHistory($id: ID!) {
    getCrudHistory(id: $id) {
      id
      createdAt
      updatedAt
      customerID
      change
      section
      tableLineID
      name
      user
      changes {
        field
        oldValue
        newValue
      }
    }
  }
`;
export const listCrudHistories = /* GraphQL */ `
  query ListCrudHistories(
    $filter: ModelCrudHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCrudHistories(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        customerID
        change
        section
        tableLineID
        name
        user
        changes {
          field
          oldValue
          newValue
        }
      }
      nextToken
    }
  }
`;
export const getReturnServiceEmailTemplates = /* GraphQL */ `
  query GetReturnServiceEmailTemplates($customerID: String!, $id: ID!) {
    getReturnServiceEmailTemplates(customerID: $customerID, id: $id) {
      id
      createdAt
      updatedAt
      customerID
      templateName
      senderAddress
      replyToAddress
      to
      cc
      bcc
      subject
      htmlBody
      automatic
    }
  }
`;
export const listReturnServiceEmailTemplates = /* GraphQL */ `
  query ListReturnServiceEmailTemplates(
    $customerID: String
    $id: ModelIDKeyConditionInput
    $filter: ModelReturnServiceEmailTemplatesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listReturnServiceEmailTemplates(
      customerID: $customerID
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        createdAt
        updatedAt
        customerID
        templateName
        senderAddress
        replyToAddress
        to
        cc
        bcc
        subject
        htmlBody
        automatic
      }
      nextToken
    }
  }
`;
export const getGLNSupplier = /* GraphQL */ `
  query GetGLNSupplier($id: ID!) {
    getGLNSupplier(id: $id) {
      id
      createdAt
      updatedAt
      customerID
      opCo
      companyCode
      supplierCode
      supplierName
      glnNumbers
    }
  }
`;
export const listGLNSuppliers = /* GraphQL */ `
  query ListGLNSuppliers(
    $filter: ModelGLNSupplierFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGLNSuppliers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        createdAt
        updatedAt
        customerID
        opCo
        companyCode
        supplierCode
        supplierName
        glnNumbers
      }
      nextToken
    }
  }
`;
export const getReceivedMessages = /* GraphQL */ `
  query GetReceivedMessages($id: ID!) {
    getReceivedMessages(id: $id) {
      id
      createdAt
      updatedAt
      customerID
      attribute1
      attribute2
      attribute3
      attribute4
      attribute5
      bodyS3Resource
      domain
      errorText
      expiresAt
      hasIgnoredFiles
      ignoreds3ResourceAttachment {
        s3Resource
      }
      s3ResourceAttachment {
        s3Resource
      }
      secondaryStatus
      senderAddress
      status
      subject
      companyCode
      integrationID
      recipientAddress
      forceValid
      processID
      processName
      history {
        id
        createdAt
        user
        description
        type
        documentChanges {
          field
          oldValue
          newValue
        }
      }
      test
    }
  }
`;
export const listReceivedMessages = /* GraphQL */ `
  query ListReceivedMessages(
    $filter: ModelReceivedMessagesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listReceivedMessages(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        customerID
        attribute1
        attribute2
        attribute3
        attribute4
        attribute5
        bodyS3Resource
        domain
        errorText
        expiresAt
        hasIgnoredFiles
        ignoreds3ResourceAttachment {
          s3Resource
        }
        s3ResourceAttachment {
          s3Resource
        }
        secondaryStatus
        senderAddress
        status
        subject
        companyCode
        integrationID
        recipientAddress
        forceValid
        processID
        processName
        history {
          id
          createdAt
          user
          description
          type
          documentChanges {
            field
            oldValue
            newValue
          }
        }
        test
      }
      nextToken
    }
  }
`;
export const getFieldActions = /* GraphQL */ `
  query GetFieldActions($customerID: String!, $id: ID!) {
    getFieldActions(customerID: $customerID, id: $id) {
      id
      filter
      type
      createdAt
      updatedAt
      customerID
      fieldName
      fieldLocation
      input
      value
      raiseOnError
      errorText
      stepIndex
      beforeProcess
      afterProcess
      method
      documentType
      documentSubType
      description
      integrationID
      requestUrl
      requestHeaders
    }
  }
`;
export const listFieldActions = /* GraphQL */ `
  query ListFieldActions(
    $customerID: String
    $id: ModelIDKeyConditionInput
    $filter: ModelFieldActionsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFieldActions(
      customerID: $customerID
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        filter
        type
        createdAt
        updatedAt
        customerID
        fieldName
        fieldLocation
        input
        value
        raiseOnError
        errorText
        stepIndex
        beforeProcess
        afterProcess
        method
        documentType
        documentSubType
        description
        integrationID
        requestUrl
        requestHeaders
      }
      nextToken
    }
  }
`;
export const getCompanyRecognitionOutcome = /* GraphQL */ `
  query GetCompanyRecognitionOutcome(
    $customerID: String!
    $documentID: String!
  ) {
    getCompanyRecognitionOutcome(
      customerID: $customerID
      documentID: $documentID
    ) {
      id
      customerID
      documentID
      success
      matchedCompanies {
        companyID
        synonym
        token
        ratio
        lengthRatio
      }
      recognizedCompanyID
      recognizedSynonym
      recognizedToken
      recognizedCertaintyScore
      textractUsed
      quickRatio
      tokensFromInvoice
      createdAt
      updatedAt
    }
  }
`;
export const listCompanyRecognitionOutcomes = /* GraphQL */ `
  query ListCompanyRecognitionOutcomes(
    $customerID: String
    $documentID: ModelStringKeyConditionInput
    $filter: ModelCompanyRecognitionOutcomeFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCompanyRecognitionOutcomes(
      customerID: $customerID
      documentID: $documentID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        customerID
        documentID
        success
        matchedCompanies {
          companyID
          synonym
          token
          ratio
          lengthRatio
        }
        recognizedCompanyID
        recognizedSynonym
        recognizedToken
        recognizedCertaintyScore
        textractUsed
        quickRatio
        tokensFromInvoice
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFieldConfiguration = /* GraphQL */ `
  query GetFieldConfiguration($id: ID!, $documentTypeConcat: String!) {
    getFieldConfiguration(id: $id, documentTypeConcat: $documentTypeConcat) {
      id
      createdAt
      updatedAt
      documentTypeConcat
      documentType
      documentSubType
      fields {
        field
        editable
        length
      }
    }
  }
`;
export const listFieldConfigurations = /* GraphQL */ `
  query ListFieldConfigurations(
    $id: ID
    $documentTypeConcat: ModelStringKeyConditionInput
    $filter: ModelFieldConfigurationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listFieldConfigurations(
      id: $id
      documentTypeConcat: $documentTypeConcat
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        createdAt
        updatedAt
        documentTypeConcat
        documentType
        documentSubType
        fields {
          field
          editable
          length
        }
      }
      nextToken
    }
  }
`;
export const getXMLTypeConfiguration = /* GraphQL */ `
  query GetXMLTypeConfiguration($id: ID!, $customerID: String!) {
    getXMLTypeConfiguration(id: $id, customerID: $customerID) {
      createdAt
      updatedAt
      id
      xmlType
      customerID
      xPath
      imageXpath
      attachmentXpath
      nameSpace
      xsltFileName
      documentType
      documentSubType
    }
  }
`;
export const listXMLTypeConfigurations = /* GraphQL */ `
  query ListXMLTypeConfigurations(
    $id: ID
    $customerID: ModelStringKeyConditionInput
    $filter: ModelXMLTypeConfigurationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listXMLTypeConfigurations(
      id: $id
      customerID: $customerID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        updatedAt
        id
        xmlType
        customerID
        xPath
        imageXpath
        attachmentXpath
        nameSpace
        xsltFileName
        documentType
        documentSubType
      }
      nextToken
    }
  }
`;
export const getRMProcessSelection = /* GraphQL */ `
  query GetRMProcessSelection($customerID: String!, $id: ID!) {
    getRMProcessSelection(customerID: $customerID, id: $id) {
      createdAt
      updatedAt
      id
      customerID
      processID
      name
      processSelection
      allowedExtension
    }
  }
`;
export const listRMProcessSelections = /* GraphQL */ `
  query ListRMProcessSelections(
    $customerID: String
    $id: ModelIDKeyConditionInput
    $filter: ModelRMProcessSelectionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listRMProcessSelections(
      customerID: $customerID
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        updatedAt
        id
        customerID
        processID
        name
        processSelection
        allowedExtension
      }
      nextToken
    }
  }
`;
export const getPeppolIdentifiers = /* GraphQL */ `
  query GetPeppolIdentifiers($endpoint: ID!) {
    getPeppolIdentifiers(endpoint: $endpoint) {
      endpoint
      customerID
      companyCode
      name
      countryCode
      documentIds
      createdAt
      updatedAt
    }
  }
`;
export const listPeppolIdentifiers = /* GraphQL */ `
  query ListPeppolIdentifiers(
    $endpoint: ID
    $filter: ModelPeppolIdentifiersFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPeppolIdentifiers(
      endpoint: $endpoint
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        endpoint
        customerID
        companyCode
        name
        countryCode
        documentIds
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDocumentIdentifiers = /* GraphQL */ `
  query GetDocumentIdentifiers($id: ID!) {
    getDocumentIdentifiers(id: $id) {
      id
      commonName
      documentIdentifier
      createdAt
      updatedAt
    }
  }
`;
export const listDocumentIdentifiers = /* GraphQL */ `
  query ListDocumentIdentifiers(
    $id: ID
    $filter: ModelDocumentIdentifiersFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDocumentIdentifiers(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        commonName
        documentIdentifier
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getDelayDocument = /* GraphQL */ `
  query GetDelayDocument($icGuid: ID!) {
    getDelayDocument(icGuid: $icGuid) {
      icGuid
      customerID
      delayStart
      delayEnd
      createdAt
      updatedAt
    }
  }
`;
export const listDelayDocuments = /* GraphQL */ `
  query ListDelayDocuments(
    $icGuid: ID
    $filter: ModelDelayDocumentFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listDelayDocuments(
      icGuid: $icGuid
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        icGuid
        customerID
        delayStart
        delayEnd
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getCustomerMailbox = /* GraphQL */ `
  query GetCustomerMailbox($mailbox: String!, $customerID: String!) {
    getCustomerMailbox(mailbox: $mailbox, customerID: $customerID) {
      mailbox
      customerID
      companyCode
      direction
      exportType
      allowedDomains
      createdAt
      updatedAt
    }
  }
`;
export const listCustomerMailboxes = /* GraphQL */ `
  query ListCustomerMailboxes(
    $mailbox: String
    $customerID: ModelStringKeyConditionInput
    $filter: ModelCustomerMailboxFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listCustomerMailboxes(
      mailbox: $mailbox
      customerID: $customerID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        mailbox
        customerID
        companyCode
        direction
        exportType
        allowedDomains
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getEasyMigration = /* GraphQL */ `
  query GetEasyMigration($customerID: String!) {
    getEasyMigration(customerID: $customerID) {
      customerID
      migratedAt
      createdAt
      updatedAt
    }
  }
`;
export const listEasyMigrations = /* GraphQL */ `
  query ListEasyMigrations(
    $customerID: String
    $filter: ModelEasyMigrationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listEasyMigrations(
      customerID: $customerID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        customerID
        migratedAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPageroClearanceConfig = /* GraphQL */ `
  query GetPageroClearanceConfig($id: ID!, $code: String!) {
    getPageroClearanceConfig(id: $id, code: $code) {
      id
      code
      country
      documentType
      pageroDocumentType
      error
      documentFieldFilter
      createdAt
      updatedAt
    }
  }
`;
export const listPageroClearanceConfigs = /* GraphQL */ `
  query ListPageroClearanceConfigs(
    $id: ID
    $code: ModelStringKeyConditionInput
    $filter: ModelPageroClearanceConfigFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPageroClearanceConfigs(
      id: $id
      code: $code
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        code
        country
        documentType
        pageroDocumentType
        error
        documentFieldFilter
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPeppolEndpointValidation = /* GraphQL */ `
  query GetPeppolEndpointValidation($isoCode: ID!, $validationType: String!) {
    getPeppolEndpointValidation(
      isoCode: $isoCode
      validationType: $validationType
    ) {
      isoCode
      validationType
      validationValue
      createdAt
      updatedAt
    }
  }
`;
export const listPeppolEndpointValidations = /* GraphQL */ `
  query ListPeppolEndpointValidations(
    $isoCode: ID
    $validationType: ModelStringKeyConditionInput
    $filter: ModelPeppolEndpointValidationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPeppolEndpointValidations(
      isoCode: $isoCode
      validationType: $validationType
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        isoCode
        validationType
        validationValue
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWebhookSubscription = /* GraphQL */ `
  query GetWebhookSubscription($customerID: String!, $subscription: String!) {
    getWebhookSubscription(
      customerID: $customerID
      subscription: $subscription
    ) {
      id
      customerID
      subscription
      endpoint
      createdAt
      updatedAt
    }
  }
`;
export const listWebhookSubscriptions = /* GraphQL */ `
  query ListWebhookSubscriptions(
    $customerID: String
    $subscription: ModelStringKeyConditionInput
    $filter: ModelWebhookSubscriptionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listWebhookSubscriptions(
      customerID: $customerID
      subscription: $subscription
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        customerID
        subscription
        endpoint
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getSmlCache = /* GraphQL */ `
  query GetSmlCache($identifier: String!) {
    getSmlCache(identifier: $identifier) {
      identifier
      smlResult
      cacheDateTime
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const listSmlCaches = /* GraphQL */ `
  query ListSmlCaches(
    $identifier: String
    $filter: ModelSmlCacheFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listSmlCaches(
      identifier: $identifier
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        identifier
        smlResult
        cacheDateTime
        expiresAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getTraceLog = /* GraphQL */ `
  query GetTraceLog($documentID: String!, $timestamp: AWSDateTime!) {
    getTraceLog(documentID: $documentID, timestamp: $timestamp) {
      documentID
      customerID
      target
      logType
      processID
      processStepID
      logStream
      message
      timestamp
      expiresAt
      createdAt
      updatedAt
    }
  }
`;
export const listTraceLogs = /* GraphQL */ `
  query ListTraceLogs(
    $documentID: String
    $timestamp: ModelStringKeyConditionInput
    $filter: ModelTraceLogFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTraceLogs(
      documentID: $documentID
      timestamp: $timestamp
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        documentID
        customerID
        target
        logType
        processID
        processStepID
        logStream
        message
        timestamp
        expiresAt
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPeppolDeployedDocumentTypes = /* GraphQL */ `
  query GetPeppolDeployedDocumentTypes($id: Int!) {
    getPeppolDeployedDocumentTypes(id: $id) {
      id
      commonName
      documentIdentifier
      processIdentifier
      updatedAt
      deprecationDate
      testOnly
      createdAt
    }
  }
`;
export const listPeppolDeployedDocumentTypes = /* GraphQL */ `
  query ListPeppolDeployedDocumentTypes(
    $id: Int
    $filter: ModelPeppolDeployedDocumentTypesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listPeppolDeployedDocumentTypes(
      id: $id
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        commonName
        documentIdentifier
        processIdentifier
        updatedAt
        deprecationDate
        testOnly
        createdAt
      }
      nextToken
    }
  }
`;
export const customerIDCreatedAtIndex = /* GraphQL */ `
  query CustomerIDCreatedAtIndex(
    $customerID: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerIDCreatedAtIndex(
      customerID: $customerID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        icGuid
        createdAt
        createdEpoch
        updatedAt
        amountGross
        amountNet1
        amountNet2
        amountNet3
        amountNetTotal
        amountVat1
        amountVat2
        amountVat3
        amountVatTotal
        appliedMapping
        bankName
        btBUMID
        btInvoiceRef
        btOrigin
        btReceiverRef
        btScanDate
        businessArea
        businessUnit
        companyID
        companyCode
        companyName
        companyNameOverride
        currency
        customerID
        deliveryDate
        deliveryTerms
        deliveryEndDate
        deliveryLocation
        deliveryInstruction
        documentNumber
        documentSubType
        documentType
        dueDate
        expiresAt
        exportApproved
        exportMapping
        exportType
        externalSystem
        externalSystemID
        forceValid
        gAccount
        gAmount
        invoiceDate
        invoiceNumber
        invoiceType
        integrationDetail
        ivsProcessID
        lastError
        noteNumber
        noteToSupplier
        opCo
        owner
        orderDate
        orderType
        paymentTerms
        pdfUploadedFrontEnd
        purchasingCategory
        poCreator
        poOwner
        purpose
        receivedMessageID
        receiverAddress1
        receiverAddress2
        receiverCity
        receiverCompanyName
        receiverCompanyCode
        receiverContractNumber
        receiverCountryCode
        receiverContactName
        receiverContactFirstName
        receiverContactPhoneNumber
        receiverContactEmailAddress
        receiverGLN
        receiverKVK
        receiverNetServiceId
        receiverOrdernumber
        receiverPostalCode
        receiverVatId
        receiverEmailAddress
        receiverEndPointIsoCode
        receiverEndPointID
        remark
        returnDate
        returnEmailAddress
        returnStatus
        s3ResourceAttachment {
          s3Resource
        }
        s3ResourceMiscellaneous {
          s3Resource
        }
        s3ResourceWebserviceResponse
        s3ResourceExportedDocument
        s3ResourceGeneratedImage
        s3ResourceOrgImage
        s3ResourceOrgXML
        source
        status
        secondaryStatus
        senderCode
        senderAddress1
        senderAddress2
        senderCompanyCode
        senderContractNumber
        senderCountryCode
        senderContactName
        senderContactFirstName
        senderContactPhoneNumber
        senderContactEmailAddress
        senderDescription
        senderDocCode
        senderDocNum
        senderEmailAddress
        senderGLN
        senderIBAN
        senderName
        senderNote
        senderReference
        senderTerms
        senderPostalCode
        senderVatId
        senderKVK
        subscriptionType
        supplierAddress1
        supplierAddress2
        supplierBBAN
        supplierCity
        supplierCountryCode
        supplierDescription
        supplierEmailAddress
        supplierGLN
        supplierIBAN
        supplierKVK
        supplierName
        supplierNetServiceId
        supplierCode
        senderRecognitionInput
        supplierRecognitionInput
        supplierOrdernumber
        supplierPostalCode
        supplierVatId
        swiftCode
        vatRate1
        vatRate2
        vatRate3
        history {
          id
          createdAt
          user
          description
          type
          documentChanges {
            field
            oldValue
            newValue
          }
        }
        lines {
          id
          lineNumber
          lineNetTotal
          lineVatRate
          lineVatAmount
          lineUnitPrice
          lineQuantity
          lineDescription
          lineUoM
          lineArticleCode
          lineSupplierArticleCode
          lineOrderNumber
          lineDiscountRate
          lineDiscountAmount
          lineDiscountName
          lineFreeNumber1
          lineFreeNumber2
          lineFreeNumber3
          lineFreeText1
          lineFreeText2
          lineFreeText3
        }
        locked
        lockedBy
        lockedSince
        hasBeenReProcessed
        sendScanReportToBasware
        scanReportCode
        scanReportDescription
        scanReportComment
        title
        linkedDocuments {
          documentID
          documentType
        }
      }
      nextToken
    }
  }
`;
export const documentNumberCustomerIDIndex = /* GraphQL */ `
  query DocumentNumberCustomerIDIndex(
    $documentNumber: String!
    $customerID: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    documentNumberCustomerIDIndex(
      documentNumber: $documentNumber
      customerID: $customerID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        icGuid
        createdAt
        createdEpoch
        updatedAt
        amountGross
        amountNet1
        amountNet2
        amountNet3
        amountNetTotal
        amountVat1
        amountVat2
        amountVat3
        amountVatTotal
        appliedMapping
        bankName
        btBUMID
        btInvoiceRef
        btOrigin
        btReceiverRef
        btScanDate
        businessArea
        businessUnit
        companyID
        companyCode
        companyName
        companyNameOverride
        currency
        customerID
        deliveryDate
        deliveryTerms
        deliveryEndDate
        deliveryLocation
        deliveryInstruction
        documentNumber
        documentSubType
        documentType
        dueDate
        expiresAt
        exportApproved
        exportMapping
        exportType
        externalSystem
        externalSystemID
        forceValid
        gAccount
        gAmount
        invoiceDate
        invoiceNumber
        invoiceType
        integrationDetail
        ivsProcessID
        lastError
        noteNumber
        noteToSupplier
        opCo
        owner
        orderDate
        orderType
        paymentTerms
        pdfUploadedFrontEnd
        purchasingCategory
        poCreator
        poOwner
        purpose
        receivedMessageID
        receiverAddress1
        receiverAddress2
        receiverCity
        receiverCompanyName
        receiverCompanyCode
        receiverContractNumber
        receiverCountryCode
        receiverContactName
        receiverContactFirstName
        receiverContactPhoneNumber
        receiverContactEmailAddress
        receiverGLN
        receiverKVK
        receiverNetServiceId
        receiverOrdernumber
        receiverPostalCode
        receiverVatId
        receiverEmailAddress
        receiverEndPointIsoCode
        receiverEndPointID
        remark
        returnDate
        returnEmailAddress
        returnStatus
        s3ResourceAttachment {
          s3Resource
        }
        s3ResourceMiscellaneous {
          s3Resource
        }
        s3ResourceWebserviceResponse
        s3ResourceExportedDocument
        s3ResourceGeneratedImage
        s3ResourceOrgImage
        s3ResourceOrgXML
        source
        status
        secondaryStatus
        senderCode
        senderAddress1
        senderAddress2
        senderCompanyCode
        senderContractNumber
        senderCountryCode
        senderContactName
        senderContactFirstName
        senderContactPhoneNumber
        senderContactEmailAddress
        senderDescription
        senderDocCode
        senderDocNum
        senderEmailAddress
        senderGLN
        senderIBAN
        senderName
        senderNote
        senderReference
        senderTerms
        senderPostalCode
        senderVatId
        senderKVK
        subscriptionType
        supplierAddress1
        supplierAddress2
        supplierBBAN
        supplierCity
        supplierCountryCode
        supplierDescription
        supplierEmailAddress
        supplierGLN
        supplierIBAN
        supplierKVK
        supplierName
        supplierNetServiceId
        supplierCode
        senderRecognitionInput
        supplierRecognitionInput
        supplierOrdernumber
        supplierPostalCode
        supplierVatId
        swiftCode
        vatRate1
        vatRate2
        vatRate3
        history {
          id
          createdAt
          user
          description
          type
          documentChanges {
            field
            oldValue
            newValue
          }
        }
        lines {
          id
          lineNumber
          lineNetTotal
          lineVatRate
          lineVatAmount
          lineUnitPrice
          lineQuantity
          lineDescription
          lineUoM
          lineArticleCode
          lineSupplierArticleCode
          lineOrderNumber
          lineDiscountRate
          lineDiscountAmount
          lineDiscountName
          lineFreeNumber1
          lineFreeNumber2
          lineFreeNumber3
          lineFreeText1
          lineFreeText2
          lineFreeText3
        }
        locked
        lockedBy
        lockedSince
        hasBeenReProcessed
        sendScanReportToBasware
        scanReportCode
        scanReportDescription
        scanReportComment
        title
        linkedDocuments {
          documentID
          documentType
        }
      }
      nextToken
    }
  }
`;
export const statusCustomerIDIndex = /* GraphQL */ `
  query StatusCustomerIDIndex(
    $status: Int!
    $customerID: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    statusCustomerIDIndex(
      status: $status
      customerID: $customerID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        icGuid
        createdAt
        createdEpoch
        updatedAt
        amountGross
        amountNet1
        amountNet2
        amountNet3
        amountNetTotal
        amountVat1
        amountVat2
        amountVat3
        amountVatTotal
        appliedMapping
        bankName
        btBUMID
        btInvoiceRef
        btOrigin
        btReceiverRef
        btScanDate
        businessArea
        businessUnit
        companyID
        companyCode
        companyName
        companyNameOverride
        currency
        customerID
        deliveryDate
        deliveryTerms
        deliveryEndDate
        deliveryLocation
        deliveryInstruction
        documentNumber
        documentSubType
        documentType
        dueDate
        expiresAt
        exportApproved
        exportMapping
        exportType
        externalSystem
        externalSystemID
        forceValid
        gAccount
        gAmount
        invoiceDate
        invoiceNumber
        invoiceType
        integrationDetail
        ivsProcessID
        lastError
        noteNumber
        noteToSupplier
        opCo
        owner
        orderDate
        orderType
        paymentTerms
        pdfUploadedFrontEnd
        purchasingCategory
        poCreator
        poOwner
        purpose
        receivedMessageID
        receiverAddress1
        receiverAddress2
        receiverCity
        receiverCompanyName
        receiverCompanyCode
        receiverContractNumber
        receiverCountryCode
        receiverContactName
        receiverContactFirstName
        receiverContactPhoneNumber
        receiverContactEmailAddress
        receiverGLN
        receiverKVK
        receiverNetServiceId
        receiverOrdernumber
        receiverPostalCode
        receiverVatId
        receiverEmailAddress
        receiverEndPointIsoCode
        receiverEndPointID
        remark
        returnDate
        returnEmailAddress
        returnStatus
        s3ResourceAttachment {
          s3Resource
        }
        s3ResourceMiscellaneous {
          s3Resource
        }
        s3ResourceWebserviceResponse
        s3ResourceExportedDocument
        s3ResourceGeneratedImage
        s3ResourceOrgImage
        s3ResourceOrgXML
        source
        status
        secondaryStatus
        senderCode
        senderAddress1
        senderAddress2
        senderCompanyCode
        senderContractNumber
        senderCountryCode
        senderContactName
        senderContactFirstName
        senderContactPhoneNumber
        senderContactEmailAddress
        senderDescription
        senderDocCode
        senderDocNum
        senderEmailAddress
        senderGLN
        senderIBAN
        senderName
        senderNote
        senderReference
        senderTerms
        senderPostalCode
        senderVatId
        senderKVK
        subscriptionType
        supplierAddress1
        supplierAddress2
        supplierBBAN
        supplierCity
        supplierCountryCode
        supplierDescription
        supplierEmailAddress
        supplierGLN
        supplierIBAN
        supplierKVK
        supplierName
        supplierNetServiceId
        supplierCode
        senderRecognitionInput
        supplierRecognitionInput
        supplierOrdernumber
        supplierPostalCode
        supplierVatId
        swiftCode
        vatRate1
        vatRate2
        vatRate3
        history {
          id
          createdAt
          user
          description
          type
          documentChanges {
            field
            oldValue
            newValue
          }
        }
        lines {
          id
          lineNumber
          lineNetTotal
          lineVatRate
          lineVatAmount
          lineUnitPrice
          lineQuantity
          lineDescription
          lineUoM
          lineArticleCode
          lineSupplierArticleCode
          lineOrderNumber
          lineDiscountRate
          lineDiscountAmount
          lineDiscountName
          lineFreeNumber1
          lineFreeNumber2
          lineFreeNumber3
          lineFreeText1
          lineFreeText2
          lineFreeText3
        }
        locked
        lockedBy
        lockedSince
        hasBeenReProcessed
        sendScanReportToBasware
        scanReportCode
        scanReportDescription
        scanReportComment
        title
        linkedDocuments {
          documentID
          documentType
        }
      }
      nextToken
    }
  }
`;
export const customerIDCreatedAtReceivedIndex = /* GraphQL */ `
  query CustomerIDCreatedAtReceivedIndex(
    $customerID: String!
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReceivedMessagesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    customerIDCreatedAtReceivedIndex(
      customerID: $customerID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        customerID
        attribute1
        attribute2
        attribute3
        attribute4
        attribute5
        bodyS3Resource
        domain
        errorText
        expiresAt
        hasIgnoredFiles
        ignoreds3ResourceAttachment {
          s3Resource
        }
        s3ResourceAttachment {
          s3Resource
        }
        secondaryStatus
        senderAddress
        status
        subject
        companyCode
        integrationID
        recipientAddress
        forceValid
        processID
        processName
        history {
          id
          createdAt
          user
          description
          type
          documentChanges {
            field
            oldValue
            newValue
          }
        }
        test
      }
      nextToken
    }
  }
`;
export const statusCustomerIDReceivedIndex = /* GraphQL */ `
  query StatusCustomerIDReceivedIndex(
    $status: Int!
    $customerID: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelReceivedMessagesFilterInput
    $limit: Int
    $nextToken: String
  ) {
    statusCustomerIDReceivedIndex(
      status: $status
      customerID: $customerID
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        createdAt
        updatedAt
        customerID
        attribute1
        attribute2
        attribute3
        attribute4
        attribute5
        bodyS3Resource
        domain
        errorText
        expiresAt
        hasIgnoredFiles
        ignoreds3ResourceAttachment {
          s3Resource
        }
        s3ResourceAttachment {
          s3Resource
        }
        secondaryStatus
        senderAddress
        status
        subject
        companyCode
        integrationID
        recipientAddress
        forceValid
        processID
        processName
        history {
          id
          createdAt
          user
          description
          type
          documentChanges {
            field
            oldValue
            newValue
          }
        }
        test
      }
      nextToken
    }
  }
`;
